import { Injectable } from '@angular/core';
import { CmsAnalyticsService } from 'idt-analytics-api/cms-analytics.service';
import { AnalyticsComponentEvent } from 'idt-analytics-api/models';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';
import { Link } from 'shared/services/links.model';

import { SliceBaseRenderComponent } from 'extensions/core/slice-base/render/slice-base-render.component';


@Injectable()
export class SliceSliderEventsService {

  constructor(
    private readonly cmsAnalyticsService: CmsAnalyticsService,
    private readonly renderStateService: RenderStateService
  ) {}

  public setAnalytics(
    slug: string,
    relatedEvent: string,
    event: AnalyticsComponentEvent,
    comp: SliceBaseRenderComponent,
    clearSubscriptions$: Subject<void>
  ) {
    if (event.carouselSlide) {
      this.trackCarouselSlide(slug, relatedEvent, event, comp, clearSubscriptions$);
      return;
    }
    this.cmsAnalyticsService.track(relatedEvent, event);
  }

  public trackCarouselSlide(
    slug: string,
    relatedEvent: string,
    event: AnalyticsComponentEvent,
    comp: SliceBaseRenderComponent,
    clearSubscriptions$: Subject<void>
  ) {
    if (!event.carouselSlide) {
      return;
    }
    this.getSlideLink(slug, event.carouselSlide, comp?.slice?.id ?? '')
      .pipe(
        takeUntil(clearSubscriptions$)
      )
      .subscribe((slideLink) => {
        if (slideLink) {
          event.categoryId = slideLink.categoryId;
          event.src = slideLink.src;
        }
        this.cmsAnalyticsService.track(relatedEvent, event);
      });
  }

  public getSlideLink(slug: string, currentIndex: string, sectionId: string): Observable<Link> {
    return this.renderStateService.getComponents$(slug).pipe(
      map((components) => this.getSlideLinkFromComponents(components, currentIndex, sectionId)),
    );
  }

  private getSlideLinkFromComponents(components: IdtComponent[], currentIndex: string, sectionId: string): Link {
    let slideLink: Link = {
      type: ''
    };

    const section = components.find((component) => component.id === sectionId);
    if (isDefined(section)) {
      const pieceId = section?.children[currentIndex] ? section?.children[currentIndex][0] : '';
      const piece = components.find((comp) => comp.id === pieceId);
      slideLink = piece?.settings?.general?.link;
    }

    return slideLink;
  }

}
